import sqftConfig from "./sqftConfig";
import sqftImageManager from "./sqftImageManager";
import sqftShapeManager from "./sqftShapeManager";
import workspace from "../core/workspace";
import slabWorkspace from "../core/slab/slabWorkspace";
import store from "../../../../../store";
import {setIsRoomSwitcherVisible} from "../../../../../actions/sqftMenuFunctions";
import sqftSlabManager from "./sqftSlabManager";
import sqftEventManager from "./sqftEventManager";
import SqftStore from "./sqftStore";

export const CANVAS_FIT_MODE = {
  WINDOW: 'window',
  CONTAINER: 'container',
};


export const enableRegularMode = () => {
  store.dispatch(setIsRoomSwitcherVisible(true));
  //sqftConfig.workspace.snapToGrid = true;
  slabWorkspace.disableSlabImages();
  slabWorkspace.deregisterEvents();
  sqftImageManager.hideSlabImages();
  sqftShapeManager.hideSeamShapes();
  sqftShapeManager.hideSlabShapes();

  sqftSlabManager.deleteShapeOffset();

  sqftImageManager.restoreTextBoxes();
  sqftImageManager.restoreImages();
  sqftShapeManager.restoreCorePieceShapes();
  sqftShapeManager.restoreShapeParts();

  slabWorkspace.slabAdditionalShapes.hideAdditionalShapes(); //this should go last
};

export const enableSlabMode = (shouldUpdatePlaceholderFeatureIds = false) => {
  store.dispatch(setIsRoomSwitcherVisible(false));
  sqftConfig.workspace.snapToGrid = false;
  sqftImageManager.restoreSlabImages();
  sqftShapeManager.checkForUpdateSlabPoints();
  sqftShapeManager.checkForUpdateSlabPosition();
  sqftShapeManager.restoreSeamShapes();
  sqftShapeManager.restoreSlabShapes();

  sqftSlabManager.reInitShapeOffset();

  slabWorkspace.slabAdditionalShapes.initWaterfallToolShapes(); // 1
  slabWorkspace.slabAdditionalShapes.initBacksplashAndEdgeShapes();
  slabWorkspace.slabAdditionalShapes.initMiteredToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.initUnderlaymentToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.initBumpoutShapes();
  slabWorkspace.slabAdditionalShapes.restoreBacksplashShapes();
  slabWorkspace.initLeftPart();

  sqftImageManager.hideImages();
  sqftImageManager.hideTextBoxes();
  sqftShapeManager.hideShapeParts();
  sqftShapeManager.hideCorePieceShapes();

  void shouldUpdatePlaceholderFeatureIds;
  // if (shouldUpdatePlaceholderFeatureIds) {
  //   window.setTimeout(() => { // first we need to enable slab mode to get slab mode coordinates for the shape
  //     sqftShapeIntersectionsManager.updateShapesIntersections();
  //     sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
  //     //sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
  //     sqftShapeIntersectionsManager.updateSlabImagesFeature();
  //     workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  //   }, 0)
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
};

export const createSlabModeWaterfallShapes = () => {
  slabWorkspace.slabAdditionalShapes.initWaterfallToolShapes(); // 1
  slabWorkspace.slabAdditionalShapes.initMiteredToolShapes(); // 2
  slabWorkspace.slabAdditionalShapes.hideAdditionalShapes(); //this should go last
}

export const clearRotateAngles = () => {
  sqftConfig.highlight.rotateAngle = false;
  const angleTooltip = document.getElementById("angle-tooltip");
  if (angleTooltip) {
    angleTooltip.style.display = "none";
  }

  workspace.getShapes().forEach((shape) => {
    if (Array.isArray(shape.rotateAngleParts) && shape.rotateAngleParts.length) {
      shape.deActivateRotateAngle();
    }
  });
}

export const getDimensionsDependingOnShapePositions = (workspace) => {
  const {minX, maxX, minY, maxY} = sqftShapeManager.getMinMaxWorkspacePoints(workspace, true);
  let maxCordX = Math.abs(minX) > Math.abs(maxX) ? Math.abs(minX) : Math.abs(maxX);
  let maxCordY = Math.abs(minY) > Math.abs(maxY) ? Math.abs(minY) : Math.abs(maxY);

  let imageWidth = maxCordX / sqftConfig.scale * Math.pow(sqftConfig.defaultScale, 2) + 500 / sqftConfig.scale * sqftConfig.defaultScale;
  let imageHeight = maxCordY / sqftConfig.scale * Math.pow(sqftConfig.defaultScale, 2) + 500 / sqftConfig.scale * sqftConfig.defaultScale;

  //todo re-wright this
  if (window.innerWidth < 1024) {
    imageWidth *= 3.75
    imageHeight *= 3.75
  }

  return [imageWidth, imageHeight]
}

export const getFontSizeFromContext = (ctx) => {
  const fontSizeMatch = ctx.font.match(/\d+/);
  return fontSizeMatch ? Number(fontSizeMatch[0]) : null;
}

/**
 * Returns logical viewport size for the workspace canvas.
 * It prefers DOM measurements, but falls back to stored values
 * when the DOM is not fully initialized (clientWidth = 0 or 1).
 */
export const getViewportSize = (canvas) => {
  // 1) Resolve the canvas element
  //    Try explicit argument -> eventManager -> DOM lookup
  if (!canvas) {
    canvas = sqftEventManager.canvas ?? document.getElementById("workspace");
  }

  // 2) Get DOM-based logical size (CSS pixels)
  //    clientWidth can be 0 or even 1 during initialization,
  //    especially when parent containers haven't been laid out yet.
  const domWidth = canvas?.clientWidth || canvas?.offsetWidth || 0;
  const domHeight = canvas?.clientHeight || canvas?.offsetHeight || 0;

  // 3) Get previously measured size from the store
  //    This is usually correct because it is updated via ResizeObserver.
  const storeWidth = SqftStore.canvas?.width || 0;
  const storeHeight = SqftStore.canvas?.height || 0;

  // 4) Choose the effective size:
  //    - If DOM reports 0 or 1 → layout not ready → fallback to store
  //    - Otherwise use DOM value
  const width = (domWidth > 1 ? domWidth : storeWidth);
  const height = (domHeight > 1 ? domHeight : storeHeight);

  return {
    canvasWidth: width,
    canvasHeight: height,
  };
};

